enum IUpdateVersion {
  Major = 'MAJOR',
  Minor = 'MINOR',
  Patch = 'PATCH',
}

export default IUpdateVersion;
